'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDispatcherUrl = function isDispatcherUrl(url) {
  return (/_api/.test(url)
  );
};

var getWindowLocationOrigin = function getWindowLocationOrigin() {
  return typeof window !== 'undefined' && window.location && window.location.origin || '';
};

var requestSuccess = function requestSuccess(config) {
  var url = config.url,
      baseURL = config.baseURL;

  var parsedBaseUrl = new _urijs2.default(baseURL);

  var relativeUrl = url.replace(baseURL, ''); //get the original relative path without baseURL
  var parsedUrl = new _urijs2.default(relativeUrl);

  if (parsedUrl.is('relative')) {
    if (parsedBaseUrl.is('relative')) {
      parsedBaseUrl.origin(getWindowLocationOrigin());
    }

    var finalUrl = isDispatcherUrl(url) ? parsedUrl.origin(parsedBaseUrl.origin()) : new _urijs2.default('' + parsedBaseUrl.toString() + relativeUrl).normalizePath();

    return Object.assign({}, config, {
      url: finalUrl.toString()
    });
  }

  return config;
};

exports.default = { requestSuccess: requestSuccess };
//# sourceMappingURL=axios-intercept-baseurl.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/src/axios-intercept-baseurl.js
// module id = 789
// module chunks = 0